import { render, staticRenderFns } from "./TShirtPrinting.vue?vue&type=template&id=99e13fb4&scoped=true"
import script from "./TShirtPrinting.vue?vue&type=script&lang=js"
export * from "./TShirtPrinting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e13fb4",
  null
  
)

export default component.exports